import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="21" height="15" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg" {...props}><g fill="none" fillRule="evenodd"><g stroke="#000" strokeLinecap="square" strokeWidth="2"><path d="M1.25 1.584h18.333M7.916 13.25h5M4.583 7.417H16.25" /></g><path d="M-10-13h40v40h-40z" /></g></svg>);